
import { defineComponent } from "vue";
import { TableEditingConfig } from "@/components/controls/catalogueGrid/tableEditingConfig";
import { TableSelectionConfig } from "@/components/controls/catalogueGrid/tableSelectionConfig";
import { TableDesignConfig } from "@/components/controls/catalogueGrid/tableDesignConfig";
import { TextColumnConfig } from "@/components/controls/catalogueGrid/columns/textColumnConfig";
import { requiredRule } from "@/components/controls/catalogueGrid/columns/baseValidationRules";
import CatalogueGrid from "@/components/controls/catalogueGrid/CatalogueGrid.vue";
import { BooleanColumnConfig } from "@/components/controls/catalogueGrid/columns/booleanColumnConfig";
import { TableExportConfig } from "@/components/controls/catalogueGrid/tableExportConfig";
import { TableImportConfig } from "@/components/controls/catalogueGrid/tableImportConfig";
import { DecimalColumnConfig } from "@/components/controls/catalogueGrid/columns/decimalColumnConfig";
import { IntegerColumnConfig } from "@/components/controls/catalogueGrid/columns/integerColumnConfig";
import store from "@/store";

export default defineComponent({
  components: {
    CatalogueGrid,
  },
  props: {
    //показатель режима выбора
    selectMode: { required: false, type: Boolean, default: false },
    gridHeight: { required: false, type: String, default: null },
    //функция для получения выбранных элементов
    getSelectedData: { type: Function },
    //функция для вызова при изменении выбранных элементов
    changeSelectedData: { type: Function },
    //модель родительского элемента
    parentModel: { required: true },
    //идет расчет плана
    isCalculation: { required: false },
    //открыты ли настройки
    isSettingsOpen: { type: Object, required: true },
  },
  methods: {
    getScrollSettings() {
      const orderSettings = (store as any).state.orderSettings.orderSettings[
        this.parentModel.id
      ];
      if (orderSettings) {
        this.designConfig.horizontalScroll = orderSettings.scroll;
      }
    },
    rememberScrollSettings(scroll: any) {
      const temp = {
        settings: {
          scroll: scroll,
        },
        index: this.parentModel.id,
      };
      store.dispatch("orderSettings/setOrderSettings", temp);
    },
    onUpdateParentModelCallback() {
      const grid = this.$refs.grid.dxGrid;
      grid.repaint();
    },
  },
  data() {
    return {
      // подробности работы custom summary см. на сервере в методе SetCustomSummary
      summaryConfig: {
        totalItems: [
          {
            name: "TotalSummary",
            showInColumn: "number",
            displayFormat: "Итог:",
            summaryType: "custom",
          },
          {
            name: "TotalVolumeSummary",
            showInColumn: "totalVolume",
            column: "totalVolume",
            valueFormat: "#,##0.#",
            displayFormat: "{0} м³",
            summaryType: "sum",
          },
          {
            name: "LoadedVolumeSummary",
            showInColumn: "loadedVolume",
            column: "loadedVolume",
            valueFormat: "#,##0.#",
            displayFormat: "{0} м³",
            summaryType: "sum",
          },
          {
            name: "ContainerCountSummary",
            showInColumn: "containerCount",
            column: "containerCount",
            valueFormat: "#,##0.#",
            displayFormat: "{0} шт",
            summaryType: "sum",
          },
        ],
      },
      editingConfig: new TableEditingConfig({
        allowUpdating: !this.isCalculation,
        allowAdding: !this.isCalculation,
        allowDeleting: !this.isCalculation,
        allowDeleteAll: !this.isCalculation,
        confirmDelete: true,
        allowDataFill: !this.isCalculation,
        allowExport: !this.isCalculation,
        allowImport: !this.isCalculation,
        allowClearFilter: true,
        allowDeleteMultipleRows: true,
        allowChangeScrollSettings: true,
        allowColumnReordering: true,
        allowResetSelectedRows: true,
        enableMasterDetail: true,
        detailComponentName:
          "components/journals/PlanOrderJournal/PlanOrderNomenclatureJournal.vue",
        mode: "row",
        chooseColumns: true,
      }),
      selectModeEditingConfig: new TableEditingConfig({
        allowUpdating: false,
        allowAdding: false,
        allowDeleting: false,
        confirmDelete: false,
        allowDataFill: false,
        allowExport: false,
        allowDeleteMultipleRows: false,
      }),
      designConfig: new TableDesignConfig({
        popUpColumnsCount: 1,
        popUpWidth: "850px",
        heightScroll: "calc(100vh - 350px)",
        horizontalScroll: true,
      }),
      columns: [
        new TextColumnConfig({
          dataField: "number",
          caption: "Номер",
          validationRules: [requiredRule],
        }),
        new TextColumnConfig({
          dataField: "clientName",
          caption: "Заказчик",
        }),
        new TextColumnConfig({
          dataField: "contractName",
          caption: "Договор",
        }),
        new DecimalColumnConfig({
          dataField: "totalVolume",
          caption: "Объем (м³)",
          decimalPoints: 1,
          readOnly: true,
        }),
        new DecimalColumnConfig({
          dataField: "loadedVolume",
          caption: "Отгружено (м³)",
          decimalPoints: 1,
          readOnly: true,
        }),
        new IntegerColumnConfig({
          dataField: "containerCount",
          caption: "Кол-во контейнеров (шт)",
          validationRules: [],
          allowEmpty: true,
        }),
        new BooleanColumnConfig({
          dataField: "isSelectedForShipment",
          caption: "Выбран для отгрузки",
        }),
      ],
      selectionConfig: new TableSelectionConfig({
        mode: "multiple",
        selectAllMode: "allPages",
        showCheckBoxesMode: "none",
      }),
      pageSizes: [10, 20, 50, 100],
      importConfig: new TableImportConfig({
        progressMethodName: "importPlanOrderProgress",
        progressEventName: "importPlanOrderProgressEvent",
        messageEventName: "importPlanOrderMessageEvent",
      }),
      exportConfig: new TableExportConfig({
        progressMethodName: "exportPlanOrderProgress",
        progressEventName: "exportPlanOrderProgressEvent",
        messageEventName: "exportPlanOrderMessageEvent",
        exportFileName: "Заказы-Opti-Loading",
      }),
    };
  },
  created() {
    this.getScrollSettings();
    if (this.selectMode) {
      this.editingConfig = this.selectModeEditingConfig;
    }
    if (this.gridHeight) {
      this.designConfig.height = this.gridHeight;
    }
  },
});
